import { render } from "./ProjectDeleteModal.vue?vue&type=template&id=36363be6"
import script from "./ProjectDeleteModal.vue?vue&type=script&lang=js"
export * from "./ProjectDeleteModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__